module.exports = __webpack_public_path__ + "static/media/dash_image.960821b5.png";